var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.username)+"，欢迎登录供应链管理系统v2.5")])])
}
var staticRenderFns = []

export { render, staticRenderFns }